<template>
    <slide class="order-flow__wrapper--8" @next="submit()" :validated="true" :overwriteSaveBtn="true" :showNextBtn="!makeOrder">
        <template slot="content">
            <div class="over-flow__text-block">
                <template v-for="(contentItem, key) in content">
                    <h3 class="over-flow__text-block__heading" v-text="contentItem.title"></h3>
                    <p v-text="contentItem.text"></p>
                    <div class="label-checkbox" v-if="contentItem.chkLabel && contentItem.chkBoxFieldName">
                        <input type="checkbox" :id="`check-${contentItem.chkBoxFieldName}`"
                            v-model="intExtraOptions[contentItem.chkBoxFieldName]" />
                        <label :for="`check-${contentItem.chkBoxFieldName}`" class="label">
                            <span class="circle"></span>
                            <span class="check"></span>
                            <span class="box"></span> {{ contentItem.chkLabel }}
                        </label>
                    </div>
                    <inputfield 
                        v-if="contentItem.chkBoxFieldName === 'registerAsCeo' && intExtraOptions.registerAsCeo " 
                        :name="contentItem.inputFieldLabel"
                        :value="intExtraOptions['emplyeeCount'] || ''"
                        @input="(val) => intExtraOptions['emplyeeCount'] = val.toString().trim()"
                        input-type="tel" mask="9999"  
                        class="label-input--full-width"></inputfield>    
                </template>
            </div>
        </template>
        <template slot="actions">
            <button v-if="makeOrder" class="btn btn--show" :class="{ 'btn--loading': loading }" @click="submit()" :disabled="loading">
                Afslut
            </button>
            <p class="error" v-if="error">Der skete en fejl under bestillingen! Tjek at du har internet og prøv igen...
            </p>
        </template>
    </slide>
</template>

<script>
import Slide from './slide.vue';
import inputfield from '../../input-field/input-field.vue';

export default {
    props: {
        loading: { type: Boolean, default: false },
        error: { type: Boolean, default: false },
        content: {
            type: Array,
            default: () => ([])
        },
        extra: { type: Object, default: () => ({}) },
        makeOrder: { type: Boolean, default: false }
    },
    data() {
        return {
            intExtraOptions: {
                emplyeeCount: ''
            }
        }
    },
    mounted() {
        this.intExtraOptions = Object.assign({}, this.intExtraOptions, this.extra);
    },
    watch: {
        extra() {
            this.intExtraOptions = Object.assign({}, this.intExtraOptions, this.extra);
        }
    },
    methods: {
        submit() {
            const emplyeeCount = this.intExtraOptions.emplyeeCount || undefined;
            const options = Object.assign({}, this.intExtraOptions, {emplyeeCount});
            this.$emit('submit', options);
        }
    },
    components: {
        'slide': Slide,
        'inputfield': inputfield
    }
}
</script>